import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Tabs } from 'antd';
import cx from 'classnames';
import './style/index.less';

class CustomTabs extends Component {
  static propTypes = {
    title: PropTypes.string,
    visible: PropTypes.bool,
    items: PropTypes.array,
    modalOpts: PropTypes.object,
    tabsOpts: PropTypes.object,
    className: PropTypes.string,
    showType: PropTypes.number, // 展示形式 0: 基础展示 1: 模态框展示
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false
    };
  }

  componentWillReceiveProps(nextProps) {
    if ('visible' in nextProps) {
      this.setState({
        visible: nextProps.visible
      });
    }
  }

  closeModal = () => {
    const { onCancel } = this.props
    onCancel && onCancel()
    this.setState({
      visible: false
    });
  };

  onOk = () => {
    const { onOk, onChange } = this.props;
    // onChange && onChange(value)
    onOk && onOk();
    this.setState({
      visible: false
    });
  };

  onShowModal = () => {
    this.setState({ visible: true });
  };

  render() {
    const {
      className,
      items,
      onCancel,
      onOk,
      modalOpts,
      tabsOpts,
      full,
      showType,
      children
    } = this.props;

    const classname = cx(className, 'antui-customTabs', { 'full-modal': full });
    const modalProps = {
      className: classname,
      visible: this.state.visible,
      destroyOnClose: true,
      onCancel: this.closeModal,
      footer: [
        onCancel && (
          <Button key="back" onClick={this.closeModal}>
            取消
          </Button>
        ),
        onOk && (
          <Button key="submit" type="primary" onClick={this.onOk}>
            确定
          </Button>
        )
      ],
      width: 800,
      ...modalOpts
    };

    const tabsProps = {
      animated: false,
      defaultActiveKey: '0',
      size: 'default',
      tabBarGutter: 10,
      ...tabsOpts,
    }

    const TabsComp = () => (<Tabs {...tabsProps}>
      {items.map((val, index) => (
        <Tabs.TabPane tab={val.title} key={index}> 
          {val.content}
        </Tabs.TabPane>
      ))}
    </Tabs>)

    return showType === 1 ? (<React.Fragment>
      <div onClick={this.onShowModal}>
        <Button className="custom-tabs-button">{children || '内部链接'}</Button>
      </div>
      <Modal {...modalProps}>
        <TabsComp />
      </Modal>
    </React.Fragment>) : <TabsComp />
  }
}

export default CustomTabs;
